import {
  validateUpper,
  validateLower,
  validateNumber,
  checkSpace,
  validateSpecialCharsInPassword,
  validateSize,
} from "@jsainsburyplc/id-ui-common";
import { matchValues } from "utils/validation";

export const validateForm = (setState, { password, confirmPassword }) => {
  const errors = {};
  if (!password) {
    errors.password = "Password is required";
  }

  if (!confirmPassword) {
    errors.confirmPassword = "Password is required";
  }

  const passwordCriteria = {
    uppercase: validateUpper(password),
    lowercase: validateLower(password),
    digit: validateNumber(password),
    length: validateSize(password, 9),
    specialChars: validateSpecialCharsInPassword(password),
    space: checkSpace(password),
  };

  setState(passwordCriteria);

  if (Object.values(passwordCriteria).includes(false)) {
    errors.password = "Your password does not meet our required criteria";
  }

  if (confirmPassword && !matchValues(password, confirmPassword)) {
    errors.confirmPassword = "Passwords don't match";
  }

  return errors;
};
